import {createSlice} from '@reduxjs/toolkit'

export const chatbotStreamSlice = createSlice({
  name: 'chatbotStream',
  initialState: {
    message: '',
    matchedProspectId: [],
    matchedProspectList: [],
    interestTagId: [],
    sessionId: null,
    llmLoader: false,
    latestResponseId: null,
    isCancelled: false,
    chatbotData: [],
    shouldResetChatView: false
  },
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload
    },
    setMatchedProspectId: (state, action) => {
      state.matchedProspectId = action.payload
    },
    setMatchedProspectList: (state, action) => {
      state.matchedProspectList = action.payload
    },
    setInterestTagId: (state, action) => {
      state.interestTagId = action.payload
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload
    },
    setLLMLoader: (state, action) => {
      state.llmLoader = action.payload
    },
    setLatestResponseId: (state, action) => {
      state.latestResponseId = action.payload
    },
    setCancellation: (state, action) => {
      state.isCancelled = action.payload
    },
    setChatbotData: (state, action) => {
      state.chatbotData = action.payload
    },
    setShouldResetChatView: (state, action) => {
      state.shouldResetChatView = action.payload
    }
  }
})

export const {
  setMessage,
  setMatchedProspectId,
  setMatchedProspectList,
  setInterestTagId,
  setSessionId,
  setLLMLoader,
  setLatestResponseId,
  setCancellation,
  setChatbotData,
  setShouldResetChatView
} = chatbotStreamSlice.actions

export default chatbotStreamSlice.reducer
